import { fetchConfig } from 'common/actions/config';
import { emailVerificationCodeCheckSuccessAction } from 'users/reducers/emailVerification';

/**
 * Email verification middleware function
 */
const middleware = (store) => (next) => (action) => {
  const { dispatch } = store;

  const result = next(action);

  switch (action.type) {
    case emailVerificationCodeCheckSuccessAction.type: {
      dispatch(fetchConfig());

      break;
    }

    default:
      break;
  }

  return result;
};

export default middleware;
